// src/components/auth/Signup.js

import Layout from "../../hocs/Layout";
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { signup } from "../../redux/actions/auth";
import { setAlert } from "../../redux/actions/alert";
import axios from "axios";

// IMPORTA EL LOGO DE GOOGLE (asegúrate de la ruta correcta)
import GOOGLE_LOGO_URL from "../../assets/google.svg";
import MICROSOFT_LOGO_URL from "../../assets/microsoft.svg";
import { useNavigate } from "react-router-dom";

const Signup = ({ signup, setAlert }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [accountCreated, setAccountCreated] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    re_password: "",
    terms: false,
  });

  const { first_name, last_name, email, password, re_password, terms } =
    formData;

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // Lógica para el signup tradicional
  const onSubmit = async (e) => {
    e.preventDefault();
    if (terms) {
      const result = await signup(
        first_name,
        last_name,
        email,
        password,
        re_password
      );

      if (result.status === 201) {
        setAccountCreated(true);
        window.scrollTo(0, 0);
        setFormData({
          first_name: "",
          last_name: "",
          email: "",
          password: "",
          re_password: "",
          terms: false,
        });
      } else if (result.status === 400) {
        const errors = result.data;
        for (const key in errors) {
          if (errors.hasOwnProperty(key)) {
            let errorMessage = errors[key].join(", ");
            if (errorMessage.includes("Ya existe Usuario con este email.")) {
              errorMessage = "A user with this email already exists.";
            }
            setAlert(errorMessage, "red");
          }
        }
      } else {
        console.error("Error:", result.data);
      }
    } else {
      window.scrollTo(0, 0);
      setAlert("You must accept the terms and conditions", "red");
    }
  };

  // Lógica para continuar con Google (Social Auth)
  const continueWithGoogle = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/auth/o/google-oauth2/?redirect_uri=${process.env.REACT_APP_API_URL}/google`
      );
      window.location.replace(res.data.authorization_url);
    } catch (err) {
      setAlert("Error connecting with Google", "red");
    }
  };

  const continueWithMicrosoft = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/auth/o/azuread-oauth2/?redirect_uri=${process.env.REACT_APP_API_URL}/microsoft`
      );
      window.location.replace(res.data.authorization_url);
    } catch (err) {
      setAlert("Error connecting with Microsoft", "red");
    }
  };

  return (
    <Layout>
      {/* Fondo blanco */}
      <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8 bg-white">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Sign Up
          </h2>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          {/* Card with white background */}
          <div className="py-8 px-10 shadow sm:rounded-lg sm:px-10 bg-white">
            <form onSubmit={onSubmit} className="space-y-6">
              <div>
                <label
                  htmlFor="first_name"
                  className="block text-sm font-medium text-gray-700"
                >
                  First Name
                </label>
                <div className="mt-1">
                  <input
                    name="first_name"
                    value={first_name}
                    onChange={onChange}
                    type="text"
                    placeholder="Enter your first name"
                    required
                    className="appearance-none block w-full px-3 py-2 
                               border border-gray-300 rounded-md shadow-sm 
                               placeholder-gray-400 focus:outline-none 
                               focus:ring-emerald-500 focus:border-emerald-500 
                               sm:text-sm"
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="last_name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Last Name
                </label>
                <div className="mt-1">
                  <input
                    name="last_name"
                    value={last_name}
                    onChange={onChange}
                    type="text"
                    placeholder="Enter your last name"
                    required
                    className="appearance-none block w-full px-3 py-2 
                               border border-gray-300 rounded-md shadow-sm 
                               placeholder-gray-400 focus:outline-none 
                               focus:ring-emerald-500 focus:border-emerald-500 
                               sm:text-sm"
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email Address
                </label>
                <div className="mt-1">
                  <input
                    name="email"
                    value={email}
                    onChange={onChange}
                    type="email"
                    placeholder="Enter your email address"
                    required
                    className="appearance-none block w-full px-3 py-2 
                               border border-gray-300 rounded-md shadow-sm 
                               placeholder-gray-400 focus:outline-none 
                               focus:ring-emerald-500 focus:border-emerald-500 
                               sm:text-sm"
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-700"
                >
                  Password
                </label>
                <div className="mt-1">
                  <input
                    name="password"
                    value={password}
                    onChange={onChange}
                    type="password"
                    placeholder="Enter your password"
                    required
                    className="appearance-none block w-full px-3 py-2 
                               border border-gray-300 rounded-md shadow-sm 
                               placeholder-gray-400 focus:outline-none 
                               focus:ring-emerald-500 focus:border-emerald-500 
                               sm:text-sm"
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="re_password"
                  className="block text-sm font-medium text-gray-700"
                >
                  Confirm Password
                </label>
                <div className="mt-1">
                  <input
                    name="re_password"
                    value={re_password}
                    onChange={onChange}
                    type="password"
                    placeholder="Confirm your password"
                    required
                    className="appearance-none block w-full px-3 py-2 
                               border border-gray-300 rounded-md shadow-sm 
                               placeholder-gray-400 focus:outline-none 
                               focus:ring-emerald-500 focus:border-emerald-500 
                               sm:text-sm"
                  />
                </div>
              </div>

              <div className="flex items-center">
                <input
                  id="terms"
                  name="terms"
                  type="checkbox"
                  onChange={onChange}
                  checked={terms}
                  className="h-4 w-4 text-emerald-600 
                             focus:ring-emerald-500 border-gray-300 rounded"
                />
                <label
                  htmlFor="terms"
                  className="ml-2 block text-sm text-gray-700"
                >
                  I accept the{" "}
                  <a
                    href="/terms"
                    className="text-emerald-600 hover:text-emerald-500"
                  >
                    Terms and Conditions
                  </a>
                </label>
              </div>

              <div>
                <button
                  type="submit"
                  className="w-full flex justify-center py-2 px-4 
                             border border-transparent rounded-md shadow-sm 
                             text-sm font-medium text-white 
                             bg-emerald-600 hover:bg-emerald-700 
                             focus:outline-none focus:ring-2 
                             focus:ring-offset-2 focus:ring-emerald-500"
                >
                  Register
                </button>
              </div>
            </form>

            {/* SEPARADOR */}
            <div className="flex items-center my-6">
              <div className="flex-grow border-t border-gray-300"></div>
              <span className="mx-2 text-gray-500">OR</span>
              <div className="flex-grow border-t border-gray-300"></div>
            </div>

            <button
              onClick={continueWithGoogle}
              type="button"
              className="w-full inline-flex items-center justify-center
             py-2 px-4 border border-gray-300 rounded-md shadow-sm
             bg-white text-gray-700 hover:bg-gray-50
             focus:outline-none focus:ring-2 focus:ring-offset-2
             focus:ring-gray-400"
            >
              <img
                src={GOOGLE_LOGO_URL}
                alt="Google Logo"
                className="h-5 w-5 mr-2"
              />
              Continue with Google
            </button>

            <div className="mt-4">
              <button
                onClick={continueWithMicrosoft}
                type="button"
                className="w-full inline-flex items-center justify-center
               py-2 px-4 border border-gray-300 rounded-md shadow-sm
               bg-white text-gray-700 hover:bg-gray-50
               focus:outline-none focus:ring-2 focus:ring-offset-2
               focus:ring-gray-400"
              >
                <img
                  src={MICROSOFT_LOGO_URL}
                  alt="Microsoft Logo"
                  className="h-5 w-5 mr-2"
                />
                Continue with Microsoft
              </button>
            </div>


          </div>
        </div>
      </div>
    </Layout>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
  signup,
  setAlert,
})(Signup);
